import getToken from "./getToken";

/**
 * Gets the list of available screens from the JWT token
 * @returns {Array<string>} Array of screen names the user has access to
 */
const getAvailableScreens = () => {
  const token = getToken();
  if (!token) return [];
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const screensClaim = payload['Screens'];
    if (!screensClaim) return [];
    
    // screensClaim is a comma-separated string: "TopSkus, MarketShare, BrandPerformance, AI"
    // Split by comma and trim whitespace
    const screens = typeof screensClaim === 'string' 
      ? screensClaim.split(',').map(s => s.trim()).filter(Boolean)
      : (Array.isArray(screensClaim) ? screensClaim : [screensClaim]);
    
    return screens;
  } catch (error) {
    console.error('Error parsing token for available screens:', error);
    return [];
  }
};

export default getAvailableScreens;
